import { render } from "./template1.vue?vue&type=template&id=6a3ccc30"
import script from "./template1.vue?vue&type=script&lang=js"
export * from "./template1.vue?vue&type=script&lang=js"

import "./template1.vue?vue&type=style&index=0&id=6a3ccc30&lang=css"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__